/**
 * Description: 表情工具组件，支持旺旺、小蜜和万象
 *
 * Author: linghao.llh@alibaba-inc.com
 * Date: 2016/12/01
 *
 */

import {WW_SMILEY, WW_BLACKLIST, XM_SMILEY, XM_BLACKLIST, WX_SMILEY, WW_BLACKLIST_EN, WW_SMILEY_EN} from './map'
const CDN_HOST = '//g.alicdn.com/crm/static/0.5.1/'

const GIF_SUPPORT_LIST = ['xm']

const LARGE_SUPPORT_LIST = ['xm', 'wx']

const GIF_EXT = '.gif'

const EXT_MAP = {
  ww: '.png',
  xm: '.png',
  wx: '.png'
}

const SMILEY_MAP = {
  ww: toMap(WW_SMILEY.concat(WW_BLACKLIST,WW_BLACKLIST_EN,WW_SMILEY_EN), 'ww'),
  xm: toMap(XM_SMILEY.concat(XM_BLACKLIST), 'xm'),
  wx: toMap(WX_SMILEY, 'wx')
}

/**
 * 将上面的数组转换为对象，key 为表情文字，value 为图片地址
 * 例如：
 * {
 *   '微笑': '//g.alicdn.com/crm/static/0.4.2/ww/001.png'
 *   ...
 * }
 *
 * @param arr {Array} map.js 中的数组
 * @param prefix {String} 类型，'ww' | 'xm' | 'wx'
 *
 * @return {Object}
 */
function toMap(arr, prefix) {
  return arr.reduce((map, item) => {
    const [code, word] = item
    map[word] = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix]
    return map
  }, {})
}

/**
 * 根据 map.js 里的数组，给每个数组元素（也是数组）加上一个图片 url，并删掉第一个元素
 *
 * @param arr {Array} map.js 中的数组
 * @param prefix {String} 类型，'ww' | 'xm' | 'wx'
 *
 * @return {Array}
 */
function toArrayWithURL(arr, prefix) {
  return arr.map((item) => {
    const [code, word] = item
    const url = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix]
    return [word, url]
  })
}

/**
 * 将 url 转为 `img` 标签
 *
 * @param url {String} 表情图片 url
 * @param text {String} 表情文字，例如 '[ww:微笑]' | '[微笑]'
 *
 * @return {String}
 */
function urlToImg(url, text) {
  return `<img alt="${text}" src="${url}">`
}

/**
 * 根据表情文字及其前缀获取其对应 url
 * 如果支持 gif，那么返回 gif 的 url
 *
 * @param prefix {String} 前缀，表示类型，例如 'ww' | 'xm' | 'wx'
 * @param word {String} 不戴带前缀的表情文字，例如 '微笑'
 * @param size {String} 大小，可选 'small', 'large'
 *
 * @return {String}
 */
function getURL(prefix, word, size = 'small') {
  const map = SMILEY_MAP[prefix]
  if (!map) return

  let url = map[word]
  if (!url) return

  if (~GIF_SUPPORT_LIST.indexOf(prefix)) {
    const ext = EXT_MAP[prefix].replace('.', '')
    url = url.replace(new RegExp(`\\.${ext}$`), GIF_EXT)
  }

  if ((size === 'large') && ~LARGE_SUPPORT_LIST.indexOf(prefix)) {
    url = url.replace(new RegExp(`(${prefix}\/\\d{3})`), '$1@2x')
  }
  return url
}

/**
 * 将文本中的所有表情文字转换为 `img` 标签
 * ie. '[ww:微笑]' -> '<img alt="[ww:微笑]" src="xxx">'
 *
 * @param str {String} 输入文本
 * @param size {String} 大小，可选 'small', 'large'
 *
 * @return {String}
 */
function toImage(str, size = 'small') {
  const reg = /\[(\w{2}:)?([^\]]+)\]/gm
  if (!reg.test(str)) return str
  return toText(str).replace(reg, (text, prefix = 'ww', word) => {
    prefix = prefix.replace(':', '')
    const url = getURL(prefix, word, size)
    return url ? urlToImg(url, text) : text
  })
}


/**
 * 将文本中的所有表情 `img` 标签转换为文字
 * ie. '<img alt="[ww:微笑]" src="xxx">' -> '[ww:微笑]'
 *
 * @param str {String} 输入文本
 *
 * @return {String}
 */
function toText(str) {
  const reg = /<img alt=["'](\[(\w{2}:)?([^\]]+)\])["'][^>]+>/gm
  if (!reg.test(str)) return str
  return str.replace(reg, (matched, text, prefix, word) => {
    return text
  })
}


const WANG_WANG = toArrayWithURL(WW_SMILEY, 'ww')
const XIAO_MI = toArrayWithURL(XM_SMILEY, 'xm')
const WAN_XIANG = toArrayWithURL(WX_SMILEY, 'wx')

export default{
  WANG_WANG,
  XIAO_MI,
  WAN_XIANG,
  toImage,
  toText
}



// WEBPACK FOOTER //
// ./node_modules/_@ali_tarzan-smiley@0.0.11@@ali/tarzan-smiley/src/smiley.js